import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId =
  "/engagement/:app_group_id/destination_canvas_notification_dismissed/:workflow_id";

export const postEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdCacheKeys: AllRouteEndpoints[] =
  ["/engagement/:app_group_id/destination_canvas_notification_dismissed/:workflow_id"];
